import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';
import { MultiSelect, MultiSelectChangeEvent } from 'primeng/multiselect';

@Component({
    selector: 'nx-edit-multiselect-input',
    template: `
    <div class="nx-edit-select">
        <label *ngIf="showLabel" for="multiSelect">{{label | translate}}<ng-container *ngIf=isRequired()>*</ng-container></label>
        <p-multiSelect
            #multiSelect
            id="multiSelect"
            optionLabel="name"
            [options]="_options"
            [(ngModel)]="selected"
            (onChange)="onInputChange($any($event))"
            [appendTo]="'body'"
            [selectedItemsLabel]="'{0} gewählt'"
            [maxSelectedLabels]="maxSelectedLabels"
            [disabled]="disabled"
            [panelStyleClass]="'nx-edit-multi-select' + (panelWidhtFull ? ' full-width' : '')"
            [placeholder]="placeholder | translate" />
        <small *ngIf="helpText">{{helpText | translate}}</small>
    </div>
  `,
    styles: [`

  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditMultiSelectInputComponent),
            multi: true
        }
    ]
})
export class EditMultiSelectInputComponent implements ControlValueAccessor, OnInit, AfterViewInit {

    @ViewChild('multiSelect') multiSelect: MultiSelect;
    _options: any[];

    ngControl: NgControl;
    @Input() filter = false;
    @Input() panelWidhtFull = false;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() helpText: string;
    @Input() maxSelectedLabels: number = 4;
    @Input() set options(options :any[]){
        this._options = options;
        if(this.selectedIds){
            this.selected = this._options.filter(option => this.selectedIds.includes(option.id));
        }
    }
    @Input() optionLabel: string = 'name';
    @Input() showLabel = true;

    selected: any[];
    selectedIds: string[];

    private onChange: (value: any[]) => void;
    private onTouched: () => void;
    disabled = false;

    constructor(
        private _injector: Injector,
        private cdr: ChangeDetectorRef
    ) {
    }
    ngAfterViewInit(): void {
        this.multiSelect.updateModel(this.selected);
        this.cdr.detectChanges();
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(selected: any[]): void {
        this.selectedIds = selected;
        // convert the array of ids to an array of objects by using
        // the available options to feed this into the multiselect
        this.selected = this._options?.filter(option => selected?.includes(option.id));
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onInputChange(event: MultiSelectChangeEvent): void {
        this.selected = event.value;
        if (this.onChange) {
            // reduce the objects to an array of ids
            this.onChange(this.selected.map(option => option.id));
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

    /**
     * Opens the dropdown and focuses the filter input
     */
    openAndFocusFilter(): void {
        // Open the dropdown
        this.multiSelect.show();

        // Wait for the dropdown panel to render, then focus the filter input
        setTimeout(() => {
            const filterInput = document.querySelector('.p-multiselect-filter') as HTMLInputElement;
            if (filterInput) {
                filterInput.focus();
            }
        }, 10);
    }

}
